const pages = {
  about: {
    hero: {
      badge: "સ્થાપના ૨૦૦૨ • ગુજરાતનું સૌથી મોટું આશ્રયસ્થાન",
      titleStart: "એક એવું ઘર જ્યાં ",
      titleHighlight: "દરેક વડીલ",
      titleEnd: " પરિવાર છે.",
      description:
        "સ્વ. શ્રી ચંપકલાલ ઘેળાભાઈ શાહના પરોપકારથી ૨૦૦૨માં સ્થપાયેલી જીવનધારા એક હૂંફભર્યું, પ્રેમભર્યું પરિવાર છે. લાંભા, અમદાવાદમાં ૧૦,૦૦૦ ચોરસ ગજના આશ્રયસ્થાનમાં માત્ર ૧૭ વૃદ્ધવસતીઓ સાથે શરૂઆત કરી, અમે આજે ગુજરાતનું સૌથી મોટું વૃદ્ધાશ્રમ છીએ, ગૌરવથી ૩૦૦થી વધુ પ્રિય વડીલોની સંભાળ રાખીએ છીએ.",
      supportCause: "અમારા ઉદ્દેશને સહકાર આપો",
      visitHome: "ઘરની મુલાકાત લો",
      quote:
        "\"સેવા એ નથી જે આપણે બીજાઓ માટે કરીએ છીએ. એ તો છે જે આપણે સાથે મળીને બનીએ છીએ.\"",
      founderName: "શ્રી મનહરલાલ શાહ",
      founderRole: "સ્થાપક ટ્રસ્ટી, Jivandhara",
      poem: {
        title: "જીવનધારા એટલે શું?",
        intro: "કોઈ પૂછે કે શું છે જીવનધારા?\nતો ગર્વથી કહું કે...",
        lines: [
          "વિશ્રામ અને વિશ્વાસનું સ્થળ છે, જીવનધારા",
          "વર્ષ 2002 માં રોપાયેલું બીજ, આજે વટવૃક્ષ છે, જીવનધારા",
          "સૂકા ભઠ્ઠ રણમાં, ઝરણાની મીઠી ધાર છે, જીવનધારા",
          "ધોમધખતા બપોરે, વડલાની શીતળ છાયા છે, જીવનધારા",
          "વડીલોના સૂના સંસારમાં, આંબા ડાળે ચહેકતી કોયલ સમી છે, જીવનધારા",
          "નિરાધારનો ઓટલો અને રોટલો છે, જીવનધારા",
          "આંસુ ભરેલી આંખોની આશ, ઘડપણનું મધુર સ્મિત છે, જીવનધારા",
          "જ્યાં ઘડપણ ઝૂલે હીંચકે ને, સંગીતના તાલે સ્તવન સંભળાય,",
          "જ્યાં સંધ્યાવંદન ને આરતી રોજ ગવાય, એવી મધુર ધૂન છે, જીવનધારા",
          "લાગણીઓ ના ધોધ વહે, જ્યાં હૂંફનો વરસાદ,",
          "પહેલા વરસાદની ભીની માટી સમી સુગંધ છે, જીવનધારા",
          "આદ્ય સ્થાપક સ્વ. શ્રી ચંપકલાલ શાહની આંખોના તારલા,",
          "પ્રભુના દુલારા, કરુણામૂર્તિ અને સાચા જનસેવક",
          "સંદીપભાઈ શાહનું સપનું છે, જીવનધારા 🙏",
          "ગુજરાત નુ ગૌરવ છે, જીવનધારા, ગુજરાત નુ ગૌરવ છે જીવનધારા 🚩",
          "માં ની નજર, બાપની હૂંફ...!",
          "એ જ તો છે, આપણી જીવનધારા! ✨",
          "આથી વિશેષ શુ કહુ? શુ છે જીવનધારા...વડીલો નુ વાત્સલ્ય ધામ છે જીવનધારા! 💜"
        ],
        authorLabel: "લેખક/ Writer",
        authorName: "Dhruti Dwivedi",
        foundation: "Jivandhara vruddhashram, Lambha",
        readMore: "વધુ વાંચો",
        close: "બંધ કરો"
      },
    },
    stats: {
      residents: "આજીવન સંભાળમાં વડીલો",
      donors: "અમને સહકાર આપતા દાતા પરિવારો",
      years: "અવિરત સેવાનાં",
      tax: "12A અને 80G કર સુસંગત",
    },
    initiatives: {
      eyebrow: "અમારી મુખ્ય પહેલો",
      heading: "કાળજી, કરુણા અને ઉદ્દેશ સાથે સેવા",
      description:
        "જીવનધારા વરિષ્ઠ નાગરિકો અને વ્યાપક સમુદાયના આરોગ્ય, ગૌરવ, પોષણ અને કલ્યાણ માટે જે મુખ્ય પહેલો દ્વારા સહારો આપે છે તે જાણો.",
      slides: {
        elderCare: {
          label: "આજીવન સંભાળ",
          title: "રહેણાંક વૃદ્ધ સંભાળ",
          body: "દરેક વસતીને આજીવન કાળજી, સાથીપણું અને વ્યક્તિગત ધ્યાન આપતું સુરક્ષિત અને કરુણાભર્યું ઘર.",
          cta: "વૃદ્ધ સંભાળ જુઓ",
        },
        healthcare: {
          label: "તબીબી સેવા",
          title: "આરોગ્ય અને પુનર્વસન",
          body: "કેમ્પસમાં ક્લિનિક, ડૉક્ટર સહારો, દવા સહાય અને કેમ્પ્સ — અમારા વડીલોને રોજ સુરક્ષિત રાખે છે.",
          cta: "આરોગ્ય સેવા જુઓ",
        },
        gaushala: {
          label: "ગૌસેવા",
          title: "વૃંદાવન ગીર ગૌશાળા",
          body: "પોષક દૂધ અને સમર્પિત ગૌસેવા જે અમારા વસતીઓને પોષે છે અને પવિત્ર પરંપરાનું સન્માન કરે છે.",
          cta: "ગૌશાળા જુઓ",
        },
        donate: {
          label: "દાન",
          title: "અમારા કારણોને સહારો આપો",
          body: "ભોજન, તબીબી સંભાળ અથવા વસતીને પ્રાયોજિત કરો — દરેક યોગદાન હૂંફ અને ગૌરવ બને છે.",
          cta: "હમણાં દાન કરો",
        },
        tiffin: {
          label: "અન્નદાન",
          title: "ટિફિન સેવા",
          body: "કાળજીથી પહોંચાડાતા પોષક ભોજન — જીવનધારાની સેવાને કેમ્પસથી આગળ લઈ જાય છે.",
          cta: "ટિફિન સેવા જુઓ",
        },
        gallery: {
          label: "પળો",
          title: "જીવનધારાની અંદરનું જીવન",
          body: "તહેવારો, સંભાળની સવારો અને સહિયારો આનંદ — અમે રોજ બનાવતા પરિવારની ઝાંખીઓ.",
          cta: "ગૅલરી જુઓ",
        },
      },
    },
    story: {
      eyebrow: "અમારી કહાણી",
      heading:
        "૨૦૦૨માં એક પિતાની નોંબલ દયાળતાએ ગુજરાતનું સૌથી મોટું વરિષ્ઠ આશ્રયસ્થાન રચ્યું.",
      chronicled: "અઢી દાયકાઓ દરમિયાન નોંધાયેલું",
      dropcap: "જી",
      p1a: "વનધારા વૃદ્ધાશ્રમ અમારા હૃદયમાં એક વિશેષ સ્થાન ધરાવે છે, કારણ કે તે અમારા જીવનમાં મારા સ્વર્ગીય પિતા શ્રી ચંપકલાલ ઘેળાભાઈ શાહની દયાળતાથી પ્રવેશ્યું. તેમણે અમદાવાદના દક્ષિણ વિસ્તારમાં નારોલ ઔદ્યોગિક વિસ્તરણ વિસ્તારની સામે આવેલી લાંભામાં ૧૦,૦૦૦ ચોરસ ગજ જમીન દાન કરીને અદ્ભુત યોગદાન આપ્યું. તેમણે આ ઘરની સ્થાપના ",
      p1bold: "૨૦૦૨",
      p1b: "માં કરી, માત્ર પાંચ ઓરડા, ભોજનાલય, સુંદર બગીચા અને શાંત મંદિરથી શરૂઆત કરી.",
      p2: "અમે તેમના માર્ગદર્શનનું નિષ્ઠાપૂર્વક પાલન કરીને જીવનધારા વૃદ્ધાશ્રમને હૂંફભર્યું, પ્રેમભર્યું અને સહાયક પરિવાર બનાવ્યું. અમારા ઉત્કૃષ્ટ ટ્રસ્ટીઓ, ઉદાર દાતાઓ અને સમર્પિત કર્મચારીઓના સહયોગથી અમે તેમના સ્વપ્નને સાકાર કર્યું, હૃદય, કરુણા અને આદરથી ભરેલું આશ્રયસ્થાન બનાવ્યું. અમારી યાત્રાને યાદ કરવું અદ્ભુત છે; માત્ર ૧૭ વસતીઓ સાથે શરૂઆત કરીને, અમે આજે ગુજરાતનું સૌથી મોટું વૃદ્ધાશ્રમ હોવાનું ગૌરવ અનુભવીએ છીએ, જેમાં ૩૬૦ વરિષ્ઠ નાગરિકો માટે જગ્યા છે.",
      p3: "જેમ જેમ અમારો જીવનધારા પરિવાર વિકસતો ગયો, અમે અમારા વડીલોની વિકસતી શારીરિક, ભાવનાત્મક અને આધ્યાત્મિક જરૂરિયાતો પૂરી કરવા માટે ઊંડી પ્રતિબદ્ધતા જાળવી રાખી. ડિસેમ્બર ૨૦૧૨માં, અમે ૨૨ ઓરડા સાથે સંકુલ ૧ શરૂ કર્યું, જેમાં અમારા વડીલોની આરામ માટે વધારાની સુવિધાઓ પણ હતી. પછી, ૨૦૧૫માં, અમે ૨૮ ઓરડા ધરાવતું સંકુલ ૨ ગૌરવથી સ્વાગત કર્યું, અને ૨૧ મે, ૨૦૨૨ના રોજ, અમે અમારા વધતા પરિવારને સમાવવા માટે સંકુલ ૩ (પ્રભા સિક્ચી સેવા સદન, શાંતિ સદન અને પ્રેમ ભવન) નું ઉદ્ઘાટન ઉજવ્યું.",
      p4: "જીવનધારામાં, અમે ખુશહાલ, ગૌરવશાળી અને સંતોષકારક વાતાવરણ પૂરું પાડવાનો લક્ષ્ય રાખીએ છીએ. દરેક વૃદ્ધ વ્યક્તિને અહીં પ્રિય માનવામાં આવે છે અને મોટો આનંદ મળે છે, જે હૃદયસ્પર્શી અને આનંદભર્યું વાતાવરણ ઊભું કરે છે. અમારા સમુદાયનો ભાગ બનવાથી, તમે અમારી સહકારિત યાત્રાને સમૃદ્ધ બનાવી શકો છો અને અમારા વસતીઓના ગૌરવ અને સુખમાં યોગદાન આપી શકો છો.",
    },
    milestones: {
      eyebrow: "સીમાચિહ્નો",
      heading: "પા સદી, એક સમયે એક વડીલ",
      m2002: {
        title: "૧૭ વસતીઓ સાથે સ્થાપના",
        body: "લાંભામાં દાનમાં મળેલી ૧૦,૦૦૦ ચોરસ ગજ જમીન પર સ્થપાયેલું, પાંચ ઓરડા, ભોજનાલય, સુંદર બગીચા અને શાંત મંદિરથી શરૂઆત.",
      },
      m2012: {
        title: "સંકુલ ૧ વિસ્તરણ",
        body: "અમારા વડીલોની સુરક્ષા અને આરામ વધારવા માટે ૨૨ ઓરડા અને વધારાની ઉપયોગી સુવિધાઓ ધરાવતું સંકુલ ૧ શરૂ કર્યું.",
      },
      m2015: {
        title: "સંકુલ ૨ નું સ્વાગત",
        body: "૨૮ પ્રીમિયમ ઓરડા ધરાવતું સંકુલ ૨ ગૌરવથી સ્વાગત કર્યું, અમારા ઝડપથી વધતા વરિષ્ઠ પરિવારને સહારવાની સંકલન ક્ષમતા વધારી.",
      },
      m2022: {
        title: "સંકુલ ૩ નું ઉદ્ઘાટન",
        body: "સંકુલ ૩ (પ્રભા સિક્ચી સેવા સદન, શાંતિ સદન અને પ્રેમ ભવન) નું ઉદ્ઘાટન કર્યું, અમારી સંપૂર્ણ સ્વાગત ક્ષમતા ૩૬૦ વડીલો સુધી વધારી.",
      },
    },
    mvv: {
      mission: {
        tag: "ધ્યેય",
        title: "અડગ સહાય અને સંભાળ",
        body: "અમારા વડીલો માટે એવી જ રીતે હાજર રહેવું જેવી રીતે માતા-પિતા દરેક પડકણ પછી પોતાના બાળકોને સહારો આપવા માટે હંમેશા ત્યાં હોય છે — તેમની ડગમગતી ઉમરે નિઃશરતી પ્રેમ, આશ્રય અને આરામ આપવું.",
      },
      vision: {
        tag: "દૃષ્ટિ",
        title: "એકાંતી માટે સંગાથી",
        body: "જેમણે ક્યારેય લગ્ન ન કર્યા, સંતાન વિનાના દંપતીઓ જેમના સુવર્ણ વર્ષો નજીક આવી રહ્યા છે, અને જેમણે પોતાના જીવનસાથી ગુમાવ્યા છે તેવા જીવંત ભાગીદારો માટે સુરક્ષિત અને હૂંફભર્યું આશ્રયસ્થાન પૂરું પાડવું, જેથી કોઈ વરિષ્ઠ નાગરિક એકલો ન રહે.",
      },
      values: {
        tag: "મૂલ્યો",
        title: "ગૌરવ, શાંતિ અને આનંદ",
        body: "ખુશહાલ અને સંતોષકારક વાતાવરણ પૂરું પાડવું જ્યાં દરેક વસતી સહજતા, આદર અને ઊંડા આધ્યાત્મિક સાંત્વનાથી જીવે. હૃદયસ્પર્શી અને આનંદભર્યું વાતાવરણ ઊભું કરવું.",
      },
    },
    triptych: {
      eyebrow: "ઘરની અંદર",
      heading: "જીવનધારાની અંદર નજીકથી જોઈએ",
      description:
        "10,000 ચોરસ ગજના વિશાળ વિસ્તારમાં ફેલાયેલ, જીવનધારા અમારા 300+ વડીલોના સંપૂર્ણ શારીરિક, તબીબી, ભાવનાત્મક અને આધ્યાત્મિક કલ્યાણ માટે ડિઝાઇન કરેલી વિશાળ, ઉચ્ચ-ગુણવત્તાની આધુનિક સુવિધાઓ પ્રદાન કરે છે.",
      careAlt: "આરામદાયક વાતાવરણમાં સંભાળ રાખનાર અને વડીલ",
      mealAlt: "ભોજનગૃહમાં વડીલો સહિયારું ભોજન કરે છે",
      medicalAlt: "વડીલને તબીબી સંભાળ આપતા ડૉક્ટર",
      morningsLabel: "આરામ અને કલ્યાણ",
      morningsText:
        "સુંદર આરામદાયક ઓરડાઓ, વિશાળ સામૂહિક ભોજનગૃહ, અમારી સ્વ-સંચાલિત વૃંદાવન ગીર ગૌશાળાનું પોષક દૂધ અને હેર સેલૂન.",
      afternoonsLabel: "સ્વાસ્થ્ય અને પુનર્વસન",
      afternoonsText:
        "ભગવાન મહાવીર મેડિકલ સેન્ટર, 24 કલાક MBBS ડૉક્ટર્સ, ફિઝિયોથેરાપી અને ગુજરાતના પ્રથમ વૃદ્ધાશ્રમ પક્ષઘાત પુનર્વસન કેન્દ્ર.",
      eveningsLabel: "આધ્યાત્મિકતા અને મનોરંજન",
      eveningsText:
        "દાદા ભગવાન જિન મંદિર, વાસુપૂજ્ય સ્વામી જૈન મંદિર, સ્વાધ્યાય હોલ, લાઇબ્રેરી, હોમ થિયેટર અને વિશેષ મનોરંજન કક્ષો.",
    },
    trustee: {
      quote:
        "\"જો તમે ક્યારેય વિચાર્યું હોય કે દયાનું એક કૃત્ય જીવન બદલી શકે કે નહીં — તો કોઈ રવિવારે અમારી મુલાકાત લો. તમે જવાબ સાથે પાછા ફરશો.\"",
      name: "શ્રીમતી સરસ્વતી જૈન",
      role: "ટ્રસ્ટી · વડીલ કલ્યાણ",
    },
    cta: {
      headingStart: "અમારા પરિવારનો ભાગ ",
      headingHighlight: "બનો.",
      description:
        "એક વડીલને પ્રાયોજિત કરો. એક ભોજન પ્રાયોજિત કરો. એક મેડિકલ દિવસ પ્રાયોજિત કરો. અથવા ફક્ત ચા માટે પધારો. સેવાનું દરેક સ્વરૂપ આવકાર્ય છે અને યાદ રખાય છે.",
      donateNow: "હમણાં દાન કરો",
      meetTrustees: "અમારા ટ્રસ્ટીઓને મળો",
      visitUs: "અમારી મુલાકાત લો",
    },
  },
  contact: {
    hero: {
      eyebrow: "સંપર્કમાં રહો",
      title: "અમારો સંપર્ક કરો",
      subtitle:
        "પ્રશ્નો, સ્વયંસેવા, ભાગીદારી — અમને તમારી પાસેથી સાંભળવું ગમશે.",
    },
    imageAlt: "Jivandhara ટ્રસ્ટ",
    info: {
      addressLabel: "સરનામું",
      addressValue: "જીવનધારા વૃદ્ધાશ્રમ, લાંભા",
      phoneLabel: "ફોન",
      phoneValue: "+91 00000 00000",
      emailLabel: "ઇમેઇલ",
      emailValue: "jivandharavrudhashram@gmail.com",
      hoursLabel: "મુલાકાતના સમય",
      hoursValueMorning: "સવારે ૯ થી બપોરે ૧૨",
      hoursValueEvening: "બપોરે ૩ થી સાંજે ૭",
    },
    form: {
      heading: "અમને સંદેશ મોકલો",
      fullName: "પૂરું નામ",
      mobile: "મોબાઇલ",
      email: "ઇમેઇલ",
      subject: "વિષય",
      message: "સંદેશ",
      submit: "સંદેશ મોકલો",
      sending: "મોકલાઈ રહ્યું છે...",
    },
    toast: {
      success: "સંદેશ મોકલાયો. અમે ટૂંક સમયમાં તમારો સંપર્ક કરીશું.",
      error: "તમારો સંદેશ મોકલી શકાયો નહીં. કૃપા કરીને ફરી પ્રયાસ કરો.",
    },
  },
};

export default pages;
